import React from "react";

export default function Body({ noHeader = false, children = "" }) {
  return (
    <div
      id="page_container"
      className={`flex-grow mx-12 ${noHeader ? "mt-12" : "mt-32"}`}
    >
      {children}
    </div>
  );
}
